<script>
  import _ from 'underscore'

  export default {
    components: {},
    props: {
      types: String,  // 空白区切りテキスト。modifier class になる
      value: Number,  // アイテム個数
    },

    data () {
      return {
        staticLabel: {
          recruiting : '★',
          procured   : '✔',
          unnecessary: '✖︎',
        },
      }
    },

    computed: {
      /**
       * 種別キーワードからなるリスト。props の types を空白文字で分割したもの
       * @return {string[]}
       */
      typesList () {
        return _.compact(this.types.split(' '))
      },

      /**
       * 基底要素ノードの class 属性値の追加分 (空白区切りの modifiers)
       * @return {string}
       */
      classAttr () {
        return this.typesList.map(type => `-${type}`).join(' ')
      },

      /**
       * バッジテキスト
       * @return {string}
       */
      content () {
        const types = this.typesList
        const { value, staticLabel } = this
        switch (types[0]) {
          case 'num' :
            return Math.max(value, 0) || 0
          case 'flag':
            return staticLabel[types[1]] || ''
          default:
            return ''
        }
      },
    },

    watch: {
    },

    created () {
    },

    mounted () {
    },

    beforeDestroy () {
    },

    methods: {
    },

    filters: {
    },
  }
</script>


<template>
  <i class="ItemBadge" :class="classAttr">{{ content }}</i>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  .ItemBadge {
    & {
      display: block;
      box-sizing: border-box;
      width: $item-badge-size;
      height: $item-badge-size;
      margin: 0;
      padding: 0;
      border: ($size-unit / 4) solid white;
      border-radius: 100%;
      color: white;
      background: gray;
      text-shadow: none;
      font-weight: bold;
      font-style: normal;
      font-size: $item-badge-font-size;
      line-height: $item-badge-size;
      text-align: center;
      white-space: nowrap;
    }

    &.-num.-owned.-usual,
    &.-num.-owned.-nico {
      background: red;
    }

    &.-num.-owned.-kira {
      background: rgb(255, 136, 0);
    }

    &.-num.-released.-usual,
    &.-num.-released.-nico {
      background: blue;
    }

    &.-num.-released.-kira {
      // background: purple;
      background: blue;
    }

    &.-flag.-procured {
      color: white;
      background: #00c209;
      font-weight: normal;
    }

    &.-flag.-recruiting,
    &.-flag.-unnecessary {
      border: none;
      color: #ff00ff;
      background: transparent;
      font-weight: normal;
      font-size: $item-badge-size;
      line-height: $item-badge-size;
      text-shadow:  0px  1px 1px white,
                    1px  1px 1px white,
                    1px  0px 1px white,
                    1px -1px 1px white,
                    0px -1px 1px white,
                   -1px -1px 1px white,
                   -1px  0px 1px white,
                   -1px  1px 1px white;
    }
  }
</style>
